import { Box } from '@bonanza-social/moonlight';
import { ChangePassword } from '../components';

function ChangePasswordModal() {
  return (
    <Box flex={1} padding="space-400">
      <ChangePassword />
    </Box>
  );
}
export default ChangePasswordModal;
